<template>
  <transition name="left">
    <div class="proyectos-container" v-if="abrir">
      <div class="proyectos-close" @click="abrir=false"></div>
      <Proyecto
        title="FRANCISCO ABELLÓ & ASOCIADOS"
        body="Asesoramiento Digital, desarrollo de software de gestión administrativa y financiera."
        imgSrc="fja.png"
      ></Proyecto>
      <Proyecto
        title="CENTRO PADME"
        body="Desarrollo e identidad de marca, Logotipo, dirección artística, Website."
        imgSrc="padme.png"
        url="https://www.brownlouis.com/"
      ></Proyecto>
      <Proyecto
        title="Cervelar"
        body="Asesoramiento Digital, Website, e-commerce."
        imgSrc="cervelar.jpg"
        url="https://www.cervelar.com.ar/"
      ></Proyecto>
      <Proyecto title="Mediconnect" imgSrc="mediconnect.jpg"></Proyecto>
      <Proyecto
        title="Prolipsis"
        imgSrc="prolipsis.jpg"
        url="http://www.prolipsisconsultora.com/"
      ></Proyecto>
      <Proyecto title="Kind App" imgSrc="kindapp.jpg"></Proyecto>
    </div>
  </transition>
</template>

<script>
import Proyecto from "@/components/Proyecto.vue";
export default {
  name: "proyectos",
  data() {
    return {
      abrir: false
    };
  },
  components: {
    Proyecto
  },
  created() {
    Event.$on("abrir-proyectos", () => (this.abrir = true));
  }
};
</script>

<style>
@import "../assets/css/proyectos.css";
</style>
